import { Upload } from "@aws-sdk/lib-storage";
import { s3AwsClient } from "../config/aws-config";
import dayjs from "dayjs";

const slugify = (text) => {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
};

const generateRandomId = (length = 8) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const uploadFileToS3 = async ({
  file,
  bucketName = process.env.REACT_APP_AWS_S3_BUCKET_NAME,
  dirName = "dojo",
  fileName,
  studentName,
  branchName,
}) => {
  const randomVal = generateRandomId(8);
  let finalFileName = fileName || file?.name || "file";

  if (branchName) {
    const slugBranch = slugify(branchName);
    const slugStudent = studentName ? slugify(studentName) : null;
    const dateStr = dayjs().format("DD-MM-YYYY");
    const extension = file?.name ? (file.name.split(".").pop() || "png") : "png";

    if (slugStudent) {
      finalFileName = `${randomVal}/${slugBranch}/${slugStudent}/${dateStr}.${extension}`;
    } else {
      finalFileName = `${randomVal}/${slugBranch}/${dateStr}.${extension}`;
    }
  } else {
    finalFileName = `${randomVal}/${finalFileName}`;
  }

  const key = `${dirName}/${finalFileName}`;
  const params = {
    Bucket: bucketName,
    Key: key,
    Body: file,
    ContentType: file?.type || "application/octet-stream",
  };

  const upload = new Upload({
    client: s3AwsClient,
    params: params,
  });

  try {
    const data = await upload.done();
    console.log(data);
    return data;
  } catch (err) {
    throw err;
  }
};
